package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.ui.navigation.AppStartViewModel
import org.koin.dsl.module

val appStartModule = module {
    factory { AppStartViewModel(get()) }
}
